// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCWnk9mBDPqTM4V6uZh_1klhjwKvqR6wKE",
  authDomain: "blockhop-e76af.firebaseapp.com",
  projectId: "blockhop-e76af",
  storageBucket: "blockhop-e76af.firebasestorage.app",
  messagingSenderId: "414584117815",
  appId: "1:414584117815:web:3f3d264d80028871c27db2",
  measurementId: "G-7336M6WTKK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig, "blockhop");
const analytics = getAnalytics(app);
export const db9 = getFirestore(app); 